import React from "react";
import { DateSinglePicker } from "./DateSinglePicker.js";
import { convertSecondsToInternalFormat, convertInternalFormatToSeconds } from "./utils.js";
function DateSinglePickerTemporary({ value, onChange, mode, ...props }) {
  const internalValue = convertSecondsToInternalFormat(value);
  function handleChange(value2) {
    onChange(convertInternalFormatToSeconds(value2, mode));
  }
  return /* @__PURE__ */ React.createElement(DateSinglePicker, { ...props, value: internalValue, onChange: handleChange });
}
export {
  DateSinglePickerTemporary
};
//# sourceMappingURL=DateSinglePickerTemporary.js.map
